export const CONTENT_META_TYPES = {
    CLASS_TYPES: 1,
    CLASS_LENGTH: 2,
    INTENSITY: 3,
    TRAINER: 4,
    EQUIPMENT: 5,
};